import { Button } from "@fluentui/react-northstar";
import React, { useCallback } from "react";

import { RRule, RRuleByDay } from "../../../../../_shared/utils/recurringHelpers";

export const ButtonWeekDay: React.FC<{
  day: RRuleByDay;
  rule: RRule;
  onRRuleChangeHandler: (rule: RRule) => void;
}> = ({ day, rule, onRRuleChangeHandler }) => {
  const sortDays = useCallback((unsortedDays: RRuleByDay[]) => {
    let requiredSortOrder = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"] as const;
    let sortedDays: RRuleByDay[] = [];

    requiredSortOrder.forEach(value => {
      if (unsortedDays.includes(value)) {
        sortedDays.push(value);
      }
    });

    return sortedDays;
  }, []);

  const onDayClickHandler = useCallback(() => {
    if (rule.byday?.includes(day)) {
      if (rule.byday.length <= 1) {
        return;
      }

      rule.byday = rule.byday.filter(r => r !== day);
    } else {
      rule.byday?.push(day);
      if (rule.byday) {
        rule.byday = sortDays(rule.byday);
      }
    }

    onRRuleChangeHandler(rule);
  }, [day, onRRuleChangeHandler, rule, sortDays]);

  return (
    <Button
      content={day[0]}
      circular
      primary={rule.byday?.includes(day)}
      onClick={e => {
        e.preventDefault();
        onDayClickHandler();
      }}
    />
  );
};
